<template>
  <div id="add-user" class="m-t-10">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">
          Nama Lengkap <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-nama"
            class="form-control"
            placeholder="Nama Lengkap"
            required
            v-model="nama"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">
          Username <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <input
            type="text"
            name="username"
            value=""
            id="input-username"
            class="form-control"
            placeholder="Username"
            required
            v-model="username"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-password">
          Password <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <input
            type="password"
            name="password"
            value=""
            id="input-password"
            class="form-control"
            placeholder="Password"
            autocomplete="on"
            required
            v-model="password"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-email"> Email </label>
        <div class="form-group">
          <input
            type="email"
            name="email"
            value=""
            id="input-email"
            class="form-control"
            placeholder="Email"
            v-model="email"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-telpon"> No. Telpon </label>
        <div class="form-group">
          <input
            type="number"
            name="telpon"
            value=""
            id="input-telpon"
            class="form-control"
            placeholder="No. Telpon"
            v-model="phone"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-role">
          Role <span class="text-danger">*</span>
        </label>
        <div class="form-group">
          <select
            name="role"
            id="input-role"
            class="form-control"
            required
            v-model="role"
          >
            <option value="2">Admin</option>
            <option value="3">User</option>
            <option value="4">Viewer</option>
          </select>
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

export default {
  name: "modal_add_user",
  data() {
    return {
      nama: null,
      username: null,
      password: null,
      email: "",
      phone: "",
      role: 2,
      id_project:
        this.$store.getters.user.id_project == 0
          ? parseInt(atob(this.$route.query.ref))
          : this.$store.getters.user.id_project,
    };
  },
  methods: {
    submitForm: function () {
      if (
        this.nama != null &&
        this.username != null &&
        this.password != null &&
        this.email != null &&
        this.role != null &&
        this.id_project != null
      ) {
        let params = {
          nama: this.$sanitize(this.nama),
          username: this.$sanitize(this.username),
          password: btoa(this.password),
          email: this.$sanitize(this.email),
          phone: this.$sanitize(this.phone),
          role: btoa(parseInt(this.role)),
          id_project: parseInt(this.id_project),
        };
        let api = process.env.VUE_APP_API_URL + "users-add";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getUser();
              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> User berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch(() => {
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      } else {
        alert("pastikan semua field terisi");
      }
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>